/**
 * BDL Personalizados — "Como funciona" (3 cards de caso de uso).
 * No mobile a foto de exemplo que aparece por cima da borda do card (mesmo
 * efeito visual do hover do desktop, resolvido em CSS puro em
 * bdl-personalizados-como-funciona.liquid) não tem ":hover" — o gatilho é
 * o card entrar na tela ao rolar a página. Só isso precisa de JS
 * (IntersectionObserver); a transição em si continua sendo CSS
 * (opacity/transform), só troca a classe que dispara.
 * Revela uma vez só (unobserve depois) — não fica entrando/saindo toda
 * hora que o card cruza a viewport.
 */
const cards = document.querySelectorAll('.bdl-personalizados-como-funciona__card-wrap');

if (cards.length && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bdl-personalizados-como-funciona__card-wrap--visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.35 }
  );

  cards.forEach((card) => observer.observe(card));
} else {
  // Sem suporte a IntersectionObserver: mostra direto, sem animação.
  cards.forEach((card) => card.classList.add('bdl-personalizados-como-funciona__card-wrap--visible'));
}
